/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_CyanInputs */

const en_booking_color_cyan = /** @type {(inputs: Booking_Color_CyanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cyan`)
};

const pl_booking_color_cyan = /** @type {(inputs: Booking_Color_CyanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błękitny`)
};

/**
* | output |
* | --- |
* | "Cyan" |
*
* @param {Booking_Color_CyanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_cyan = /** @type {((inputs?: Booking_Color_CyanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_CyanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_cyan(inputs)
	return en_booking_color_cyan(inputs)
});